<div class="tw-flex tw-items-center">
    <app-icon name="course-black" type="colors" class="big-icon"></app-icon>
    <div class="tw-overflow-hidden tw-ps-1">
        <div class="name">{{ course.name }}</div>
        <div class="tw-flex tw-items-center">
            <app-icon name="clock" class="tw-w-3 tw-h-3 tw-me-1"></app-icon>
            <div class="tw-text-xs tw-text-black">{{ course.duration | time: { type: 'short' } }}</div>
        </div>
    </div>
</div>
